import { FC } from "react";
import { TravelInfoWrapper } from "./styles";
import { AboutTravel } from "../AboutTravel";

export const TravelInfo: FC = () => (
  <TravelInfoWrapper>
    <AboutTravel />
  </TravelInfoWrapper>
);
